import {
    FormControl,
    InputAdornment,
    MenuItem,
    Typography,
} from '@mui/material';
import PSPLogo from 'components/psp-logo/psp-logo';
import { Select } from 'formik-mui';
import { getPspLabel, normalizePspCode, pspLabel } from 'utils/psp';
import React from 'react';

export const PSPSelector = (props: any) => {
    const labels: Record<string, string> = {
        all: 'همه',
        ...Object.fromEntries(
            Object.keys(pspLabel).map((psp) => [psp, getPspLabel(psp)]),
        ),
    };
    const value = normalizePspCode(props?.field?.value) || 'all';
    return (
        <FormControl fullWidth>
            <Select
                {...props}
                value={value}
                onChange={(e: any) => {
                    if (e?.target?.value) {
                        props.form.setFieldValue(
                            props.field.name,
                            e.target.value,
                        );
                    } else {
                        console.warn('Unexpected event:', e);
                    }
                }}
                renderValue={(selected) => {
                    const selectedOption = Object.keys(labels).find(
                        (psp: any) => {
                            return psp === selected;
                        },
                    );
                    return selectedOption ? labels[selectedOption] : '';
                }}
                startAdornment={
                    <InputAdornment
                        position="start"
                        sx={{
                            padding: '0px !important',
                            paddingRight: '30px !important',
                            marginRight: '20px',
                            transform: 'translateX(12px)',
                        }}>
                        {value && value !== 'all' ? (
                            <PSPLogo psp={value} width="26px" height="26px" />
                        ) : (
                            <i
                                className="fa-regular fa-university"
                                style={{ fontSize: '20px' }}></i>
                        )}
                    </InputAdornment>
                }>
                <MenuItem key="all" value="all">
                    <i
                        className="fa-regular fa-university"
                        style={{
                            fontSize: '20px',
                            marginLeft: '16px',
                            marginRight: '4px',
                        }}></i>
                    <Typography>همه</Typography>
                </MenuItem>
                {Object.keys(pspLabel).map((psp: any) => (
                    <MenuItem key={psp} value={psp}>
                        <PSPLogo psp={psp} width="26px" height="26px" />
                        <Typography>{getPspLabel(psp)}</Typography>
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
    );
};
